module.exports = {"371121001":"洪凝街道","371121002":"高泽街道","371121102":"街头镇","371121103":"潮河镇","371121104":"许孟镇","371121105":"于里镇","371121106":"汪湖镇","371121107":"叩官镇","371121108":"中至镇","371121110":"松柏镇","371121201":"石场乡","371121202":"户部乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371121.json
// module id = 1570
// module chunks = 0